import { getTaxonomiesBuildResponse } from '@/api/give/taxonomies';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { apiCap } from '@gik/api';
import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { baseFallback, ISRRevalidateTimeout } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { TipsSamplePage } from '@gik/marketing/pages/TipsSamplePage';
import type { TipsSamplePageServerProps } from '@gik/marketing/pages/TipsSamplePage/TipsSamplePage';
import { SWRConfig } from 'swr';

export default function TipsSamplePageComp({ fallback }: FallbackProps<TipsSamplePageServerProps>) {
  return withTitle(
    'Tips & Sample Pages',
    <SWRConfig value={{ fallback }}>
      <TipsSamplePage />
    </SWRConfig>
  );
}

TipsSamplePageComp.getLayout = function getLayout(page: React.ReactElement, layoutProps: PageLayoutProps) {
  return <PageLayout {...layoutProps}>{page}</PageLayout>;
};

async function _getStaticProps() {
  const situations = getTaxonomiesBuildResponse('situation', { page: 1, perPage: apiCap });

  return baseFallback(
    {
      [situations.key]: await situations.json,
    },
    undefined,
    ISRRevalidateTimeout.extraSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
